
import DnRadio from '@digitalnatives/radio';

export default {
    extends: DnRadio
};
